import { axiosBeelineRequest } from '@beef/utils';
import qs from 'query-string';
import { SBER_ENDPOINTS } from "../endpoints";
import { simpleGetRequest } from "../helpers";
export var fetchSberData = simpleGetRequest(SBER_ENDPOINTS.sberRequestInfo);
export var fetchSberBinding = simpleGetRequest(SBER_ENDPOINTS.sberBinding);
export var sberPaymentRequest = function sberPaymentRequest(ctn, fromCtn, bindingId, sum, captcha // TODO: 2077
) {
  return axiosBeelineRequest({
    method: 'post',
    url: SBER_ENDPOINTS.payment,
    params: {
      ctn: ctn,
      sum: sum,
      fromCtn: fromCtn,
      bindingId: bindingId
    },
    data: qs.stringify({
      captcha: captcha
    }),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
export var fetchSberPaymentStatus = function fetchSberPaymentStatus(id) {
  return axiosBeelineRequest({
    url: SBER_ENDPOINTS.sberStatus,
    params: {
      id: id
    }
  });
};